import React from 'react';
import AddIcon from '@material-ui/icons/Add';

const InstitutionsListItemPlaceholder = () => (
    <div className="col-lg-3 col-md-6 col-sm-12">
        <div className="item placeholder">
            <div className="inner">
                <div className="top">
                    <div className="dates">
                        <span className="placeholder-line"></span>
                    </div>
                </div>
                <div className="title">
                    <span className="placeholder-line"></span>
                    <span className="placeholder-line"></span>
                </div>
                <div className="excerpt">
                    <span className="placeholder-line"></span>
                    <span className="placeholder-line"></span>
                </div>
                <div className="bottom">
                    <span className="btn-more">
                        <AddIcon className="m-icon" />
                    </span>
                </div>
            </div>
        </div>
    </div>
);

export default InstitutionsListItemPlaceholder;


// WEBPACK FOOTER //
// ./src/features/Institutions/components/List/InstitutionsListItemPlaceholder.js